import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=2b13592c&lang=html&"
import script from "./VideoComponent.vue?vue&type=script&lang=js&"
export * from "./VideoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b13592c')) {
      api.createRecord('2b13592c', component.options)
    } else {
      api.reload('2b13592c', component.options)
    }
    module.hot.accept("./VideoComponent.vue?vue&type=template&id=2b13592c&lang=html&", function () {
      api.rerender('2b13592c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/VideoComponent.vue"
export default component.exports